<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="true"
    content-class="bg-white b-1 bc-outlined-gray"
    offset="5"
    eager
  >
    <template #activator="{ props }">
      <button
        v-bind="props"
        :ripple="false"
        class="bg-white c-black fullheight fullwidth rounded pa-3 focus-very-visible"
      >
        <v-row>
          <v-col
            class="ta-left"
            cols="10"
          >
            <div class="fs-16 mb-1">
              {{ $bct('Method of transportation') }}
            </div>
            <div class="fs-16 fw-600">
              {{ $bct(travelMode || 'Show commutes by') }}
            </div>
          </v-col>
          <v-col
            class="d-flex align-center justify-end"
            cols="2"
          >
            <v-icon icon="expand_more" />
          </v-col>
        </v-row>
      </button>
    </template>

    <v-list
      @update:selected="$emit('update:modelValue', $event)"
      :selected="modelValue"
      mandatory
    >
      <v-list-item
        v-for="(type, index) in $a.assets.transit_options"
        :key="index"
        :value="type.value"
      >
        <v-list-item-title :id="'transit_option_' + index">
          {{ $bct(type.text) }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script setup>
const $bct = inject('translator');

defineProps({
  modelValue: {
    type: String,
    default: null,
  },
  travelMode: {
    type: String,
    default: null,
  },
});

defineEmits(['update:modelValue']);

const menu = ref(false);

const open = () => {
  menu.value = true;
};

defineExpose({ open });
</script>
